module.exports = __webpack_public_path__ + "static/media/flyerPinamar.1a128d87.webp";